export default __webpack_public_path__ + "static/media/hipercard.1b1eed22.svg";